<template>
    <div>
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="669.7px"
	 height="188.3px" viewBox="0 0 669.7 188.3" style="enable-background:new 0 0 669.7 188.3;" xml:space="preserve">
<g id="pantalla_6_2_">
	<g id="XMLID_10_">
		<rect id="XMLID_1709_" x="50.8" y="51.4" class="st6" width="236" height="32"/>
		<rect id="XMLID_1698_" x="50.8" y="83.4" class="st6" width="236" height="32"/>
		<rect id="XMLID_1687_" x="50.8" y="115.4" class="st6" width="236" height="32"/>
		<rect id="XMLID_1676_" x="50.8" y="147.4" class="st6" width="236" height="32"/>
		<rect id="XMLID_1596_" x="50.8" y="16.4" class="st67" width="236" height="35"/>
		<rect id="XMLID_1421_" x="286.8" y="51.4" class="st6" width="166" height="32"/>
		<rect id="XMLID_1418_" x="286.8" y="83.4" class="st6" width="166" height="32"/>
		<rect id="XMLID_1416_" x="286.8" y="115.4" class="st6" width="166" height="32"/>
		<rect id="XMLID_1412_" x="286.8" y="147.4" class="st6" width="166" height="32"/>
		<rect id="XMLID_1366_" x="286.8" y="16.4" class="st67" width="166" height="35"/>
		<rect id="XMLID_1437_" x="452.8" y="51.4" class="st6" width="166" height="32"/>
		<rect id="XMLID_1436_" x="452.8" y="83.4" class="st6" width="166" height="32"/>
		<rect id="XMLID_1435_" x="452.8" y="115.4" class="st6" width="166" height="32"/>
		<rect id="XMLID_1434_" x="452.8" y="147.4" class="st6" width="166" height="32"/>
		<rect id="XMLID_1423_" x="452.8" y="16.4" class="st67" width="166" height="35"/>
		<g id="XMLID_1575_">
			<rect id="XMLID_1439_" x="99.3" y="27.5" class="st241" width="137" height="15.5"/>
			<text transform="matrix(1 0 0 1 125.894 39.499)" class="st110 st285">Compuesto</text>
		</g>
		<g id="XMLID_1354_">
			<rect id="XMLID_1442_" x="300.8" y="27.5" class="st241" width="137" height="15.5"/>
			<text transform="matrix(1 0 0 1 330.2754 39.499)" class="st110 st285">TWA - ppm</text>
		</g>
		<g id="XMLID_1360_">
			<rect id="XMLID_1446_" x="468.3" y="27.5" class="st241" width="137" height="15.5"/>
			<text transform="matrix(1 0 0 1 496.3477 39.499)" class="st110 st285">IDLH - ppm</text>
		</g>
		<g id="XMLID_1570_">
			<rect id="XMLID_1447_" x="59.7" y="60.6" class="st241" width="203.1" height="15.5"/>
			<text transform="matrix(1 0 0 1 59.7085 72.7256)"><tspan x="0" y="0" class="st135 st285">Sulfuro de Hidrogeno - H</tspan><tspan x="175.1" y="0" class="st135 st284">2</tspan><tspan x="181.6" y="0" class="st135 st285">S</tspan></text>
		</g>
		<g id="XMLID_739_">
			<rect id="XMLID_1452_" x="336.4" y="60.6" class="st241" width="65.8" height="15.5"/>
			<text transform="matrix(1 0 0 1 365.125 72.7256)" class="st135 st285">1</text>
		</g>
		<g id="XMLID_230_">
			<rect id="XMLID_1448_" x="503.9" y="60.6" class="st241" width="65.8" height="15.5"/>
			<text transform="matrix(1 0 0 1 524.1768 72.7256)" class="st135 st285">100</text>
		</g>
		<g id="XMLID_252_">
			<rect id="XMLID_1445_" x="336.4" y="91.6" class="st241" width="65.8" height="15.5"/>
			<text transform="matrix(1 0 0 1 360.9009 103.7256)" class="st135 st285">25</text>
		</g>
		<g id="XMLID_233_">
			<rect id="XMLID_1444_" x="503.9" y="91.6" class="st241" width="65.8" height="15.5"/>
			<text transform="matrix(1 0 0 1 519.9521 103.7256)" class="st135 st285">1200</text>
		</g>
		<g id="XMLID_278_">
			<rect id="XMLID_1438_" x="336.4" y="123.6" class="st241" width="65.8" height="15.5"/>
			<text transform="matrix(1 0 0 1 342.626 135.7256)" class="st135 st285">0 (cero)</text>
		</g>
		<g id="XMLID_234_">
			<rect id="XMLID_1432_" x="503.9" y="123.6" class="st241" width="65.8" height="15.5"/>
			<text transform="matrix(1 0 0 1 524.1768 135.7256)" class="st135 st285">100</text>
		</g>
		<g id="XMLID_326_">
			<rect id="XMLID_1411_" x="336.4" y="155.6" class="st241" width="65.8" height="15.5"/>
			<text transform="matrix(1 0 0 1 358.7842 167.7256)" class="st135 st285">0,5</text>
		</g>
		<g id="XMLID_235_">
			<rect id="XMLID_1406_" x="503.9" y="155.6" class="st241" width="65.8" height="15.5"/>
			<text transform="matrix(1 0 0 1 528.4014 167.7256)" class="st135 st285">10</text>
		</g>
		<g id="XMLID_1420_">
			<rect id="XMLID_1403_" x="59.7" y="92.8" class="st241" width="196.5" height="15.5"/>
			<text transform="matrix(1 0 0 1 59.7085 104.877)" class="st135 st285">Monóxido de carbono - CO</text>
		</g>
		<g id="XMLID_1415_">
			<rect id="XMLID_1338_" x="59.7" y="124.9" class="st241" width="192.5" height="15.5"/>
			<text transform="matrix(1 0 0 1 59.7085 137.0283)"><tspan x="0" y="0" class="st135 st285">Dióxido de Azufre - SO</tspan><tspan x="156.4" y="0" class="st135 st284">2</tspan></text>
		</g>
		<g id="XMLID_1410_">
			<rect id="XMLID_1330_" x="59.7" y="157.1" class="st241" width="137" height="15.5"/>
			<text transform="matrix(1 0 0 1 59.7085 169.1797)"><tspan x="0" y="0" class="st135 st285">Cloro - Cl</tspan><tspan x="64.5" y="0" class="st135 st284">2</tspan><tspan x="71" y="0" class="st135 st285"> </tspan></text>
		</g>
	</g>
</g>
</svg>

    </div>
</template>

<script>
export default {
    data() {
        return {
        }
    },
  methods: {
    },
    mounted() {
    },
}
</script>


<style lang="scss" scoped>
	.st0{fill:none;stroke:url(#XMLID_2661_);stroke-width:6;stroke-miterlimit:10;}
	.st1{fill:#46535B;}
	.st2{fill:#ABBFC6;}
	.st3{fill:#AC7B63;}
	.st4{fill:#105477;}
	.st5{fill:#106489;}
	.st6{fill:none;stroke:#23CAD9;stroke-width:0.5;stroke-miterlimit:10;}
	.st7{fill:url(#XMLID_2624_);stroke:#383838;stroke-miterlimit:10;}
	.st8{fill:#E0B192;}
	.st9{fill:#E0E2DE;}
	.st10{fill:none;stroke:url(#XMLID_2481_);stroke-width:2;stroke-miterlimit:10;}
	.st11{fill:none;stroke:url(#XMLID_2482_);stroke-width:2;stroke-miterlimit:10;}
	.st12{fill:none;stroke:url(#XMLID_2483_);stroke-width:2;stroke-miterlimit:10;}
	.st13{fill:none;stroke:#353535;stroke-width:2;stroke-miterlimit:10;}
	.st14{fill:#132C33;}
	.st15{fill:#E1E1E1;}
	.st16{fill:none;stroke:url(#XMLID_2674_);stroke-width:6;stroke-miterlimit:10;}
	.st17{fill:#32ADF0;stroke:#32ADF0;stroke-width:11;stroke-miterlimit:10;}
	.st18{fill:url(#XMLID_2426_);stroke:#383838;stroke-miterlimit:10;}
	.st19{fill:url(#XMLID_2448_);stroke:#232323;stroke-miterlimit:10;}
	.st20{fill:none;stroke:#1D1D1B;stroke-miterlimit:10;}
	.st21{clip-path:url(#XMLID_509_);}
	.st22{clip-path:url(#XMLID_3056_);}
	.st23{fill:#4C4C4C;}
	.st24{fill:#E89C2E;}
	.st25{fill:#E8B897;}
	.st26{filter:url(#Adobe_OpacityMaskFilter);}
	.st27{fill:none;stroke:url(#XMLID_2684_);stroke-width:6;stroke-miterlimit:10;}
	.st28{fill:none;stroke:url(#XMLID_2685_);stroke-width:6;stroke-miterlimit:10;}
	.st29{fill:#B0D882;}
	.st30{fill:none;stroke:url(#XMLID_2688_);stroke-width:6;stroke-miterlimit:10;}
	.st31{fill:url(#XMLID_2432_);stroke:#383838;stroke-miterlimit:10;}
	.st32{fill:url(#XMLID_2435_);stroke:#383838;stroke-miterlimit:10;}
	.st33{fill:none;stroke:url(#XMLID_2866_);stroke-width:5;stroke-miterlimit:10;}
	.st34{fill:#B4754D;}
	.st35{fill:#28F7D1;stroke:#23CAD9;stroke-width:0.5;stroke-miterlimit:10;}
	.st36{fill:#B4B4B4;}
	.st37{fill:#B50D3D;}
	.st38{opacity:0.17;fill:#1D1D1B;}
	.st39{fill:#B5B5B5;}
	.st40{fill:none;stroke:#32ADF0;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:9.0305,5.644;}
	.st41{fill:#B7B7B7;}
	.st42{fill:#1D1D1B;}
	.st43{fill:#B8BAB5;}
	.st44{fill:#EDEDED;}
	.st45{fill:#505154;}
	.st46{fill:none;stroke:url(#XMLID_3050_);stroke-width:4;stroke-miterlimit:10;}
	.st47{fill:url(#XMLID_2445_);stroke:#383838;stroke-miterlimit:10;}
	.st48{fill:#513B1E;}
	.st49{fill:#EF5A24;}
	.st50{fill:#EF8425;}
	.st51{fill:none;stroke:#969696;stroke-miterlimit:10;}
	.st52{fill:url(#XMLID_2502_);stroke:#232323;stroke-miterlimit:10;}
	.st53{fill:url(#XMLID_1702_);}
	.st54{fill:#544733;}
	.st55{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}
	.st56{fill:none;stroke:url(#XMLID_2055_);stroke-width:5;stroke-miterlimit:10;}
	.st57{fill:none;stroke:url(#XMLID_2056_);stroke-width:5;stroke-miterlimit:10;}
	.st58{fill:#54D354;}
	.st59{fill:#555555;}
	.st60{fill:#555D60;}
	.st61{fill:none;stroke:url(#XMLID_2647_);stroke-width:4;stroke-miterlimit:10;}
	.st62{fill:none;stroke:url(#XMLID_2648_);stroke-width:4;stroke-miterlimit:10;}
	.st63{fill:#56361A;}
	.st64{fill:#BAC8D1;}
	.st65{fill:#F9385D;stroke:#23CAD9;stroke-width:0.5;stroke-miterlimit:10;}
	.st66{fill:#BB8062;}
	.st67{fill:#C7EE95;stroke:#23CAD9;stroke-width:0.5;stroke-miterlimit:10;}
	.st68{fill:none;stroke:url(#XMLID_2063_);stroke-width:5;stroke-miterlimit:10;}
	.st69{fill:none;stroke:url(#XMLID_2065_);stroke-width:5;stroke-miterlimit:10;}
	.st70{opacity:0.58;fill:#FFFFFF;}
	.st71{fill:#2368D9;}
	.st72{fill:#23CAD9;}
	.st73{fill:none;stroke:url(#XMLID_2689_);stroke-width:5;stroke-miterlimit:10;}
	.st74{fill:#F4C4A4;}
	.st75{fill:none;stroke:url(#XMLID_2867_);stroke-width:4;stroke-miterlimit:10;}
	.st76{opacity:0.4;fill:#1D1D1B;}
	.st77{fill:none;stroke:url(#XMLID_2728_);stroke-width:5;stroke-miterlimit:10;}
	.st78{fill:url(#XMLID_2522_);stroke:#232323;stroke-miterlimit:10;}
	.st79{fill:url(#XMLID_2501_);stroke:#383838;stroke-miterlimit:10;}
	.st80{fill:none;stroke:url(#XMLID_2485_);stroke-width:5;stroke-miterlimit:10;}
	.st81{fill:#28F7D1;}
	.st82{fill:none;stroke:url(#XMLID_2487_);stroke-width:5;stroke-miterlimit:10;}
	.st83{fill:none;stroke:#32ADF0;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:8.5477,5.3423;}
	.st84{fill:none;stroke:url(#XMLID_2488_);stroke-width:5;stroke-miterlimit:10;}
	.st85{fill:#F7F7F7;}
	.st86{fill:#F7F8F9;}
	.st87{fill:url(#XMLID_2505_);stroke:#383838;stroke-miterlimit:10;}
	.st88{fill:url(#XMLID_2506_);stroke:#383838;stroke-miterlimit:10;}
	.st89{fill:none;stroke:#32ADF0;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:7.6408,4.7755;}
	.st90{fill:#5E5E5E;}
	.st91{fill:none;stroke:url(#XMLID_2690_);stroke-width:5;stroke-miterlimit:10;}
	.st92{fill:#F9385D;}
	.st93{opacity:0.35;fill:#9FEDFF;}
	.st94{fill:none;stroke:url(#XMLID_2554_);stroke-width:6;stroke-miterlimit:10;}
	.st95{fill:none;stroke:url(#XMLID_2697_);stroke-width:5;stroke-miterlimit:10;}
	.st96{fill:none;stroke:url(#XMLID_2254_);stroke-width:4;stroke-miterlimit:10;}
	.st97{fill:none;stroke:url(#XMLID_2698_);stroke-width:5;stroke-miterlimit:10;}
	.st98{fill:#C07E61;}
	.st99{fill:#C12F52;}
	.st100{fill:none;stroke:#32ADF0;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:7.8706,4.9191;}
	.st101{fill:#C1A880;}
	.st102{fill:url(#XMLID_2474_);stroke:#383838;stroke-miterlimit:10;}
	.st103{fill:#939FA3;}
	.st104{fill:#93ADAD;}
	.st105{fill:url(#XMLID_2479_);stroke:#383838;stroke-miterlimit:10;}
	.st106{fill:#943B8A;}
	.st107{fill:#C3CDDD;}
	.st108{fill:#C54EB9;}
	.st109{fill:#2B2B2B;}
	.st110{font-family:'FontBase-SemiBold';}
	.st111{fill:url(#XMLID_2057_);}
	.st112{fill:url(#XMLID_2061_);}
	.st113{fill:url(#XMLID_2064_);}
	.st114{fill:url(#XMLID_2067_);}
	.st115{fill:url(#XMLID_2068_);}
	.st116{fill:url(#XMLID_2069_);}
	.st117{fill:url(#XMLID_2127_);}
	.st118{fill:url(#XMLID_2131_);}
	.st119{fill:url(#XMLID_2132_);}
	.st120{fill:url(#XMLID_2140_);}
	.st121{fill:url(#XMLID_2141_);}
	.st122{fill:url(#XMLID_2144_);}
	.st123{fill:url(#XMLID_2146_);}
	.st124{fill:url(#XMLID_2147_);}
	.st125{fill:url(#XMLID_2150_);}
	.st126{fill:#C7EE95;}
	.st127{fill:#C7F2E9;}
	.st128{fill:none;stroke:#042AB2;stroke-width:3;stroke-miterlimit:10;}
	.st129{fill:url(#XMLID_2238_);}
	.st130{fill:#99845F;}
	.st131{fill:url(#XMLID_2248_);}
	.st132{fill:url(#XMLID_2249_);}
	.st133{fill:url(#XMLID_2253_);}
	.st134{fill:none;stroke:#28F7D1;stroke-width:2;stroke-miterlimit:10;}
	.st135{font-family:'FontBase-Regular';}
	.st136{fill:url(#XMLID_2355_);}
	.st137{fill:url(#XMLID_2358_);}
	.st138{fill:url(#XMLID_2359_);}
	.st139{fill:url(#XMLID_2374_);}
	.st140{fill:url(#XMLID_2375_);}
	.st141{fill:url(#XMLID_2425_);}
	.st142{fill:url(#XMLID_2430_);}
	.st143{fill:url(#XMLID_2431_);}
	.st144{fill:url(#XMLID_2436_);}
	.st145{fill:url(#XMLID_2440_);}
	.st146{fill:url(#XMLID_2441_);}
	.st147{fill:url(#XMLID_2442_);}
	.st148{fill:url(#XMLID_2443_);}
	.st149{fill:url(#XMLID_2444_);}
	.st150{fill:url(#XMLID_2449_);}
	.st151{fill:url(#XMLID_2473_);}
	.st152{fill:url(#XMLID_2480_);}
	.st153{fill:url(#XMLID_2489_);}
	.st154{fill:url(#XMLID_2490_);}
	.st155{fill:url(#XMLID_2491_);}
	.st156{fill:url(#XMLID_2493_);}
	.st157{fill:url(#XMLID_2496_);}
	.st158{fill:#FF3BCC;}
	.st159{fill:url(#XMLID_2500_);}
	.st160{fill:url(#XMLID_2503_);}
	.st161{fill:url(#XMLID_2504_);}
	.st162{fill:url(#XMLID_2507_);}
	.st163{fill:url(#XMLID_2508_);}
	.st164{fill:url(#XMLID_2509_);}
	.st165{fill:url(#XMLID_2510_);}
	.st166{fill:url(#XMLID_2511_);}
	.st167{fill:url(#XMLID_2512_);}
	.st168{fill:url(#XMLID_2523_);}
	.st169{fill:url(#XMLID_2524_);}
	.st170{fill:url(#XMLID_2535_);}
	.st171{fill:url(#XMLID_2536_);}
	.st172{fill:url(#XMLID_2537_);}
	.st173{fill:url(#XMLID_2539_);}
	.st174{fill:#FF7676;}
	.st175{fill:url(#XMLID_2540_);}
	.st176{fill:url(#XMLID_2541_);}
	.st177{fill:url(#XMLID_2544_);}
	.st178{fill:url(#XMLID_2545_);}
	.st179{fill:#FF88A4;}
	.st180{fill:url(#XMLID_2553_);}
	.st181{fill:url(#XMLID_2563_);}
	.st182{fill:url(#XMLID_2582_);}
	.st183{fill:url(#XMLID_2585_);}
	.st184{fill:url(#XMLID_2591_);}
	.st185{fill:url(#XMLID_2597_);}
	.st186{fill:#FFAF50;}
	.st187{fill:#FFB236;}
	.st188{fill:#FFC555;}
	.st189{fill:#FFC892;}
	.st190{fill:#FFD773;}
	.st191{fill:#FFEB99;}
	.st192{fill:#FFFF00;}
	.st193{fill:#FFFFFF;}
	.st194{fill:url(#XMLID_2601_);}
	.st195{fill:url(#XMLID_2608_);}
	.st196{fill:url(#XMLID_2610_);}
	.st197{fill:url(#XMLID_2521_);stroke:#383838;stroke-miterlimit:10;}
	.st198{fill:url(#XMLID_2625_);}
	.st199{fill:url(#XMLID_2627_);}
	.st200{fill:url(#XMLID_2629_);}
	.st201{fill:url(#XMLID_2543_);stroke:#232323;stroke-miterlimit:10;}
	.st202{fill:url(#XMLID_2630_);}
	.st203{fill:url(#XMLID_2632_);}
	.st204{fill:url(#XMLID_2639_);}
	.st205{fill:url(#XMLID_2640_);}
	.st206{fill:url(#XMLID_2641_);}
	.st207{fill:url(#XMLID_2644_);}
	.st208{fill:url(#XMLID_2649_);}
	.st209{fill:url(#XMLID_2656_);}
	.st210{fill:url(#XMLID_2658_);}
	.st211{fill:url(#XMLID_2676_);}
	.st212{fill:url(#XMLID_2678_);}
	.st213{fill:url(#XMLID_2679_);}
	.st214{fill:url(#XMLID_2680_);}
	.st215{fill:url(#XMLID_2686_);}
	.st216{fill:url(#XMLID_2687_);}
	.st217{fill:url(#XMLID_2691_);}
	.st218{fill:url(#XMLID_2692_);}
	.st219{fill:none;stroke:#F9385D;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st220{fill:none;stroke:#F9385D;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
	.st221{fill:url(#XMLID_2700_);}
	.st222{fill:url(#XMLID_2525_);stroke:#383838;stroke-miterlimit:10;}
	.st223{fill:url(#XMLID_2735_);}
	.st224{fill:url(#XMLID_2766_);}
	.st225{fill:url(#XMLID_2779_);}
	.st226{fill:url(#XMLID_2805_);}
	.st227{fill:url(#XMLID_2825_);}
	.st228{fill:url(#XMLID_2860_);}
	.st229{fill:url(#XMLID_2861_);}
	.st230{fill:url(#XMLID_2863_);}
	.st231{fill:url(#XMLID_2864_);}
	.st232{fill:url(#XMLID_2869_);}
	.st233{fill:url(#XMLID_2870_);}
	.st234{fill:url(#XMLID_2871_);}
	.st235{fill:url(#XMLID_2875_);}
	.st236{fill:url(#XMLID_2883_);}
	.st237{fill:url(#XMLID_2890_);}
	.st238{fill:url(#XMLID_2891_);}
	.st239{fill:url(#XMLID_2892_);}
	.st240{fill:url(#XMLID_2899_);}
	.st241{fill:none;}
	.st242{fill:url(#XMLID_2907_);}
	.st243{fill:url(#XMLID_2968_);}
	.st244{fill:#666461;}
	.st245{fill:#9A5F3E;}
	.st246{fill:#9BC16B;}
	.st247{fill:#68696D;}
	.st248{fill:#CCCCCC;}
	.st249{fill:#CCD8E2;}
	.st250{fill:#303233;}
	.st251{fill:none;stroke:#32ADF0;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:7.8702,4.9189;}
	.st252{fill:url(#XMLID_2534_);stroke:#383838;stroke-miterlimit:10;}
	.st253{fill:none;stroke:url(#XMLID_2357_);stroke-miterlimit:10;}
	.st254{fill:#28F7D1;stroke:#042AB2;stroke-width:3;stroke-miterlimit:10;}
	.st255{fill:#32ADF0;}
	.st256{fill:none;stroke:#BCBCBC;stroke-miterlimit:10;}
	.st257{fill:#353535;}
	.st258{fill:#353638;}
	.st259{fill:none;stroke:url(#XMLID_2437_);stroke-width:2;stroke-miterlimit:10;}
	.st260{fill:none;stroke:url(#XMLID_2438_);stroke-width:2;stroke-miterlimit:10;}
	.st261{fill:none;stroke:url(#XMLID_2439_);stroke-width:2;stroke-miterlimit:10;}
	.st262{fill:none;stroke:url(#XMLID_2626_);stroke-width:6;stroke-miterlimit:10;}
	.st263{fill:none;stroke:url(#XMLID_2628_);stroke-width:6;stroke-miterlimit:10;}
	.st264{fill:url(#XMLID_2542_);stroke:#383838;stroke-miterlimit:10;}
	.st265{fill:url(#XMLID_2546_);stroke:#383838;stroke-miterlimit:10;}
	.st266{fill:#003449;}
	.st267{fill:#004263;}
	.st268{fill:#006384;}
	.st269{fill:#006937;}
	.st270{fill:#008FB6;}
	.st271{fill:none;stroke:#042AB2;stroke-width:2;stroke-miterlimit:10;}
	.st272{fill:url(#XMLID_2606_);stroke:#232323;stroke-miterlimit:10;}
	.st273{fill:#020202;}
	.st274{fill:#D0D0D0;}
	.st275{fill:none;stroke:#2368D9;stroke-width:3;stroke-miterlimit:10;}
	.st276{fill:none;stroke:url(#XMLID_2771_);stroke-width:5;stroke-miterlimit:10;}
	.st277{fill:#D29472;}
	.st278{fill:#042AB2;}
	.st279{fill:none;stroke:url(#XMLID_2634_);stroke-width:6;stroke-miterlimit:10;}
	.st280{fill:none;stroke:url(#XMLID_2635_);stroke-width:6;stroke-miterlimit:10;}
	.st281{fill:url(#XMLID_2551_);stroke:#383838;stroke-miterlimit:10;}
	.st282{fill:none;stroke:#32ADF0;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:8.7526,5.4704;}
	.st283{fill:#3A2914;}
	.st284{font-size:13;}
	.st285{font-size:17;}
	.st286{fill:url(#XMLID_3022_);}
	.st287{fill:url(#XMLID_3024_);}
	.st288{fill:url(#XMLID_3039_);}
	.st289{fill:url(#XMLID_3040_);}
	.st290{fill:url(#XMLID_3042_);}
	.st291{fill:url(#XMLID_3043_);}
	.st292{fill:url(#XMLID_3045_);}
	.st293{fill:url(#XMLID_3046_);}
	.st294{fill:url(#XMLID_3048_);}
	.st295{fill:url(#XMLID_3049_);}
	.st296{fill:url(#XMLID_3055_);}
	.st297{fill:none;stroke:#686868;stroke-miterlimit:10;}
	.st298{fill:url(#XMLID_463_);}
	.st299{fill:url(#XMLID_464_);}
	.st300{fill:url(#XMLID_496_);}
	.st301{fill:#3D3D3D;}
	.st302{fill:url(#XMLID_507_);}
	.st303{fill:url(#XMLID_510_);}
	.st304{fill:url(#XMLID_512_);}
	.st305{fill:url(#XMLID_514_);}
	.st306{fill:#D82A53;}
	.st307{mask:url(#XMLID_2134_);}
	.st308{mask:url(#XMLID_2143_);}
	.st309{mask:url(#XMLID_2149_);}
	.st310{mask:url(#XMLID_2240_);}
	.st311{fill:none;stroke:#32ADF0;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:7.289,4.5557;}
	.st312{fill:#707070;}
	.st313{clip-path:url(#XMLID_2484_);}
	.st314{clip-path:url(#XMLID_2486_);}
	.st315{fill:none;stroke:url(#XMLID_2643_);stroke-width:6;stroke-miterlimit:10;}
	.st316{fill:none;stroke:url(#XMLID_2646_);stroke-width:6;stroke-miterlimit:10;}
	.st317{clip-path:url(#XMLID_2642_);}
	.st318{clip-path:url(#XMLID_2645_);}
	.st319{clip-path:url(#XMLID_2677_);}
	.st320{fill:#A2A599;}
	.st321{fill:#A2A7AC;}
	.st322{fill:none;stroke:#28F7D1;stroke-miterlimit:10;}
	.st323{fill:#A4704C;}
	.st324{clip-path:url(#XMLID_2905_);}
	.st325{fill:none;stroke:#32ADF0;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:8.339,5.2119;}
	.st326{fill:url(#XMLID_2603_);stroke:#383838;stroke-miterlimit:10;}
	.st327{fill:#DA9571;}
	.st328{fill:#DB6812;}
	.st329{fill:#0D1F30;}
	.st330{fill:none;stroke:#545454;stroke-width:3;stroke-miterlimit:10;}
	.st331{fill:#A8A8A8;}
	.st332{fill:#DCFFF8;}
	.st333{fill:none;stroke:#23CAD9;stroke-miterlimit:10;}
	.st334{fill:#0F0F0F;}
	.st335{fill:#0F4B63;}
	.st336{fill:#DDE5ED;}
	.st337{fill:url(#XMLID_2427_);stroke:#232323;stroke-miterlimit:10;}
	.st338{fill:#424242;}
	.st339{fill:none;stroke:#32ADF0;stroke-width:2;stroke-miterlimit:10;}
	.st340{filter:url(#Adobe_OpacityMaskFilter_1_);}
	.st341{filter:url(#Adobe_OpacityMaskFilter_2_);}
	.st342{filter:url(#Adobe_OpacityMaskFilter_3_);}
	.st343{fill:url(#XMLID_2614_);stroke:#383838;stroke-miterlimit:10;}
	.st344{opacity:0.51;fill:#FFFFFF;enable-background:new    ;}
	.st345{fill:#444444;}
	.st346{fill:none;stroke:url(#XMLID_2356_);stroke-miterlimit:10;}
</style>